import { render } from "./RecyclableSortableItems.vue?vue&type=template&id=40c58992"
import script from "./RecyclableSortableItems.vue?vue&type=script&lang=js"
export * from "./RecyclableSortableItems.vue?vue&type=script&lang=js"

import "./RecyclableSortableItems.vue?vue&type=style&index=0&id=40c58992&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.26.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__